import { useApolloClient } from "@apollo/client";
import { type PropsWithChildren, useMemo } from "react";

import { useToken } from "../../../../providers/token";
import { useOakStreamClient } from "../../../../stream/useOakStreamClient";
import { ScoutConversationController } from "./scoutConversationController";
import { ScoutConversationControllerContext } from "./scoutConversationControllerContext";

export function ScoutConversationControllerProvider({ children }: PropsWithChildren) {
  const apolloClient = useApolloClient();
  const streamClient = useOakStreamClient();
  const { getIdTokenRefreshIfExpired } = useToken();
  const controller = useMemo(
    () =>
      new ScoutConversationController({
        apolloClient,
        streamClient,
        getIdTokenRefreshIfExpired,
      }),
    [apolloClient, getIdTokenRefreshIfExpired, streamClient]
  );

  return (
    <ScoutConversationControllerContext.Provider value={controller}>
      {children}
    </ScoutConversationControllerContext.Provider>
  );
}
